var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("Score: "+_vm._s(_vm.score)+" | Sets: "+_vm._s(_vm.numberSets)+" | Cards Left: "+_vm._s(_vm.cardsLeft)+" |")])}
var staticRenderFns = []

export { render, staticRenderFns }